"use strict";
// As per https://bit.dev/speedlo/hooks/use-deep-memo
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepMemo = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
/**
 * This hook memoizes a result using deep equality, which is something
 * useMemo() doesn't do out-of-the-box.
 */
const useDeepMemo = (memoFn, key) => {
    const ref = (0, react_1.useRef)();
    if (!ref.current || !(0, lodash_1.isEqual)(key, ref.current.key)) {
        ref.current = { key, value: memoFn() };
    }
    return ref.current.value;
};
exports.useDeepMemo = useDeepMemo;
